module.exports = __webpack_public_path__ + "static/ebr-5-4b516bd46b827e304ed6c1d0927ff30c.jpg";